<template>
    <div class="container">
        <content-header title="Урсодезоксихолевая кислота в гастроэнтерологической практике"/>
        <div class="article-detail">
            <div class="comment_box">
                <div class="date">
                    <div class="value">06 СЕН 18</div>
                    <div class="arrow_date"></div>
                </div>
                <div class="comments_number">0 Комментарии</div>
            </div>
            <div class="article-detail__content">
                <div class="article-detail-top">
                    <div class="article-detail__title">
                        <h2>Урсодезоксихолевая кислота в гастроэнтерологической практике</h2>
                    </div>
                    <a href="http://5-clinic.com/урсодезоксихолевая-кислота-в-гастро/" class="article-detail__image">
                        <img src="../../assets/images/staticPages/научная-статья-540x280.jpg" alt="научная-статья"
                             height="300" width="480"/>
                    </a>
                </div>

                <div class="article-detail__desc">
                    <div style="padding: 10px 0">
                        <strong>Научная статья наших
                            <router-link :to="{name: 'Наши Врачи'}"
                                         style="display: inline-block" class="link">врачей
                            </router-link>
                        </strong>
                        <div class="divider"></div>
                        <div class="flex">
                            <div class="box">
                                <img src="../../assets/images/staticPages/Шиндина-Татьяна-Сергеевна.png"
                                     alt="Шиндина-Татьяна-Сергеевна" height="100" width="150"/>
                                <div style="width: 220px; display: inline-block">
                                    <h3 style="font-size: 15px; font-weight: bold; color: #666">Шиндина Татьяна
                                        Сергеевна</h3>
                                    <p>Заведующая отделением
                                        Врач гастроэнтеролог
                                        Кандидат медицинских наук</p>
                                </div>
                            </div>
                            <div class="box">
                                <img src="../../assets/images/staticPages/Кропова-Ольга-Евгеньевна.png"
                                     alt="Кропова-Ольга-Евгеньевна" height="100" width="150"/>
                                <div style="width: 220px; display: inline-block">
                                    <h3 style="font-size: 15px; font-weight: bold; color: #666">Кропова Ольга
                                        Евгеньевна</h3>
                                    <p>Врач терапевт</p>
                                </div>
                            </div>
                        </div>
                        <div class="divider"></div>
                        <p>Авторы: Минушкин О.Н. 1 , Фролова А.А. 1 , Шиндина Т.С. 2 , Кропова О.Е. 2 , Михайлова Е.В. 3<br>
                            1 ФГБУ ДПО «Центральная ГМА» УДП РФ, Москва <br>
                            2 ФГБУ «Поликлиника No 5» УДП РФ, Москва<br>
                            3 Российско-Израильский медицинский центр «Рамбам», Москва</p>
                        <p><strong>В статье представлено описание широкого спектра эффектов урсодезоксихолевой кислоты.
                            Приводятся данные клинических исследований, проведенных с использованием российского
                            препарата на основе урсодезоксихолевой кислоты — Урдокса.</strong></p>
                        <p>Урсодезоксихолевая кислота (УДХК) давно применяется не только с целью растворения
                            холестериновых камней. Широкий спектр эффектов позволил ей найти применение в терапии
                            большого количества гастроэнтерологических заболеваний, и показания к ее использованию
                            продолжают расширяться.</p>
                        <p><strong>Роль желчных кислот в метаболических процессах организма человека</strong></p>
                        <p>В результате метаболизма холестерина в гепатоците образуются первичные желчные кислоты (ЖК):
                            холевая и хенодезоксихолевая. Они подвергаются конъюгации, секретируются в желчь, а далее в
                            тонкий кишечник. Большая часть ЖК подвергается обратному активному и пассивному всасыванию в
                            тонком кишечнике. Около 10–20% первичных ЖК минуют илеоцекальный клапан и метаболизируются с
                            участием бактерий толстого кишечника во вторичные ЖК (дезоксихолевую, литохолевую,
                            7-кетолитохолевую). Третичные ЖК (урсодезоксихолевая и сульфолитохолевая) образуются в
                            результате метаболизма вторичных ЖК в печени или кишечнике [1, 2]. Таким образом, УДХК — это
                            третичная ЖК, которая является составным компонентом желчи человека, и ее содержание
                            составляет 5% общего пула ЖК [1]. <br>
                            ЖК подразделяются на гидрофобные (холевая, дезоксихолевая, литохолевая) и гидрофильные
                            (урсодезоксихолевая и хенодезоксихолевая).
                            К эффектам гидрофобных ЖК относятся [2]:<br>
                            участие в пищеварении;<br>
                            стимуляция выхода в желчь холестерина и фосфолипидов;<br>
                            снижение выработки α-интерферона гепатоцитами;<br>
                            детергентные свойства.
                            К эффектам гидрофильных ЖК относятся [2]:<br>
                            пищеварительные эффекты;<br>
                            снижение кишечной абсорбции холестерина;<br>
                            ухудшение детергентных свойств гидрофобных ЖК;<br>
                            стимуляция выработки α-интерферона гепатоцитами.<br>
                            Накопление гидрофобных ЖК вследствие их детергентных свойств в печени или воздействие их на
                            слизистую оболочку пищеварительного тракта приводит к различным повреждающим эффектам
                            мембран, провоспалительному эффекту, оксидативному стрессу и, в итоге, к некрозу или
                            апоптозу [2–7].<br>
                            Показано, что длительный пероральный прием УДХК в дозе 10–15 мг/кг/сут приводит к повышению
                            ее содержания в пуле ЖК до 40–90% и снижению концентрации эндогенных ЖК [2, 8, 9],
                            увеличивается содержание УДХК в печеночной ткани (до 30%); при этом снижается концентрация
                            эндогенных ЖК в плазме крови, преимущественно за счет холевой кислоты, и повышается общая
                            концентрация ЖК за счет УДХК (до 60%) [7, 10–12]. Таким образом, УДХК является конкурентным
                            ингибитором основных ЖК на всех уровнях их физиологического действия: молекулярном,
                            клеточном, тканевом и системном [13].</p>
                        <p><strong>Лечебные эффекты УДХК</strong></p>
                        <p>Холеретический, антихолестатический эффект: усиливает синтез и активирует выведение из
                            гепатоцита ЖК — стимулирует экзоцитоз в гепатоцитах, усиливает бикарбонатный холерез,
                            приводящий к выведению гидрофобных ЖК в кишечник [7], а также увеличивает сократительную
                            активность желчного пузыря [1, 14, 15].<br>
                            Гепато-, цитопротективный эффект: вытесняет гидрофобные токсичные ЖК из пула ЖК, оказывает
                            гепато- и цитопротективное действие на слизистую оболочку органов гастродуоденальной зоны
                            [16, 17]. В экспериментальной модели показано, что УДХК снижает накопление токсичных ЖК в
                            печени, увеличивает секрецию ЖК в желчь [18]. УДХК встраивается в мембрану гепатоцита, делая
                            ее более устойчивой к воздействию токсичных факторов (мембраностабилизирующий эффект) [19].
                            В экспериментальных работах был доказан гепато- и цитопротективный эффект УДХК, особенно в
                            отношении повреждений печени, вызванных ЖК и алкоголем [1, 7, 14].<br>
                            Иммуномодулирующий, противовоспалительный, иммуносупрессивный эффект: уменьшает экспрессию
                            молекул HLA (главный комплекс гистосовместимости) на холангиоцитах и гепатоцитах, что
                            предотвращает активацию цитотоксичных Т-лимфоцитов; уменьшает продукцию провоспалительных
                            цитокинов (ИЛ-1, -2, -4, -6, ФНО-α, ИФН-γ); снижает синтез IgM, G, А, уменьшает продукцию
                            аутоантител [1, 7, 14, 20–23].<br>
                            Антифибротический эффект: ингибирует пролиферативную активность фибробластов [1, 14, 24];
                            обладает непрямым антифибротическим эффектом, который складывается из ее
                            противовоспалительного, антиапоптотического, антиоксидантного, гепато- и цитопротективного
                            эффектов [25, 26].<br>
                            Гипохолестеринемический: уменьшает всасывание холестерина в кишечнике, уменьшает экскрецию
                            холестерина в желчь [27, 28]. Существуют данные, что УДХК и ее конъюгаты оказывают
                            ингибирующее действие на гидроксиметилглутарил-КоА-редуктазу и активируют
                            7-α-холестеролгидроксилазу и лецитинхолестеринацилтрансферазу, снижая синтез и ускоряя
                            метаболизм холестерина [1, 14, 29–31].<br>
                            Литолитический эффект: уменьшает содержание холестерина в желчи [27–31], снижая ее
                            литогенность, стимулирует выход холестерина из камней в желчь [1, 14].<br>
                            Антиоксидантный эффект: препятствует образованию свободных радикалов, подавляет процессы
                            перекисного окисления липидов (ПОЛ), снижает содержание продуктов ПОЛ, снижает активность
                            супероксиддисмутазы [1, 14, 32], восстанавливает уровень сывороточного глутатиона [33].<br>
                            Антиапоптотический эффект: оказывает прямое антиапоптотическое действие, блокируя активацию
                            каскада апоптоза гепатоцитов и холангиоцитов за счет увеличения концентрации ионизированного
                            кальция в клетках и фосфорилирования протеинкиназы С [34]; подавляет экспрессию гена р53,
                            ингибирует циклин D1 и каспазонезависимый механизм [20, 35, 36]; блокирует митохондриальный
                            путь апоптоза [37]. В экспериментальной модели показано, что совместное добавление в
                            культуру клеток УДХК и различных проапоптотических факторов (этанола, гидрофобных ЖК,
                            Fas-лиганда, трансформирующего фактора роста β) снижало апоптоз на 50–100% [38]. УДХК
                            обладает непрямым антиапоптотическим действием,<br>
                            т. к. подавляет апоптоз, вызванный токсичными ЖК [20].<br>
                            Антипролиферативный эффект: обладает широким антипролиферативным действием, в т. ч. в ряде
                            случаев индуцирует апоптоз [39]; ингибирует деградацию ядерного фактора каппа В (NF-κB) и
                            его ингибитора [20] путем взаимодействия с рецепторами глюкокортикоидов и регуляции
                            транскрипции ДНК [20, 40].</p>
                        <p><strong>Побочные эффекты УДХК</strong></p>
                        <p>После приема внутрь большая часть УДХК всасывается в тонком кишечнике. По системе портальной
                            вены поступает в печень, где подвергается конъюгации с глицином и таурином, затем она
                            секретируется в желчь и поступает в двенадцатиперстную кишку. В кишечнике метаболизируется с
                            образованием 7-кетолитохолевой или литохолевой кислот. Литохолевая кислота является
                            гидрофобной токсичной ЖК, она способствует холестазу, способна вызывать разрывы ДНК,
                            является комутагеном. При этом основной ЖК, выявляемой в экскрементах пациентов, получающих
                            УДХК, является литохолевая кислота [20, 41–44].<br>
                            УДХК угнетает апоптоз, который необходим для удаления поврежденных клеток, в т. ч. клеток с
                            поврежденной ДНК, поэтому угнетение апоптоза приводит к повышению риска онкологических
                            заболеваний [20, 45, 46]. С другой стороны, воздействие УДХК на NF-κB оказывает
                            антипролиферативное действие и может тормозить онкогенез [20, 47, 48].<br>
                            Эксперименты на клеточных культурах показали дозозависимое действие УДХК на пролиферацию
                            клеток и апо­п­тоз [49]. А клинические исследования продемонстрировали, что у больных
                            первичным склерозирующим холангитом (ПСХ) при приеме УДХК в высоких дозах (28–30 мг/кг)
                            увеличивался риск колоректальной неоплазии, с другой стороны, при приеме в низких дозах
                            (8–15 мг/кг) такой риск снижался [50].<br>
                            УДХК обладает глюкокортикоподобным эффектом. Поскольку УДХК имеет химическое и структурное
                            сходство со стероидными гормонами, она может дозозависимо активировать их ядерные рецепторы,
                            в т. ч. оказывая сходное иммуномодулирующее действие (влияет на синтез простагландинов,
                            активность фосфолипазы А2 и пр.) [20, 51, 52]. Существуют данные о развитии синдрома отмены
                            при прекращении приема УДХК, сходного с синдромом отмены, вызванного прекращением приема
                            стероидных гормонов (повышается уровень сывороточного билирубина и активность трансаминаз)
                            [20].<br>
                            УДХК оказывает влияние на метаболизм ксенобиотиков. В экспериментальных работах показано,
                            что УДХК способна активировать цитохром Р450, другие цитохромы (CYP3A1/2, CYP2E1, CYP2B1/2,
                            CYP1A2, CYP1A1, CYP4A) и ингибировать их инактивацию [20, 53].</p>
                        <p><strong>УДХК в лечении гастроэнтерологических заболеваний</strong></p>
                        <p>В связи с множественными эффектами УДХК был накоплен обширный опыт ее применения у
                            гастроэнтерологических больных, а также продолжаются исследования по ее применению в
                            эндокринологии, кардиологии, неврологии, онкологии. Эффекты УДХК в лечении
                            гастроэнтерологических заболеваний представлены в таблице 1.</p>
                        <img src="../../assets/images/staticPages/18-1.png" alt="" height="563" width="401"/>
                        <p>В основе первичного билиарного цирроза (ПБЦ) лежит иммунное воспаление желчных протоков,
                            приводящее к холестазу, апоптозу эпителия желчных протоков (дуктопении) и прогрессирующему
                            фиброзу печени. УДХК воздействует на основные звенья патогенеза ПБЦ: обладает холеретическим
                            действием, препятствуя холестазу, проявляет цитопротективное и антиапоптотическое действие в
                            отношении гепатоцитов и холангиоцитов [54, 55]. Также она обладает противовоспалительной и
                            непрямой анти­фибротической активностью [25, 26].<br>
                            <strong>Первичный склерозирующий холангит</strong> (ПСХ) — это хроническое прогрессирующее
                            холестатическое
                            заболевание печени, характеризующееся воспалением и фиброзом внутри- и внепеченочных желчных
                            протоков, приводящее к облитерации последних и формированию стриктур с исходом в цирроз
                            печени [56]. Использование УДХК в лечении ПСХ до сих пор остается предметом обсуждения [50],
                            тем не менее она сохраняет свое место в лечении ПСХ по данным ведущих зарубежных и
                            отечественных рекомендаций [56, 57]. Главными механизмами действия УДХК являются
                            холеретический и цитопротективный эффекты, снижение гидрофобности и токсичности желчи,
                            иммуномодулирующий эффект, способность влиять на апоптоз и пролиферацию клеток [50, 58].<br>
                            <strong>Алкогольная болезнь печени</strong> (АБП) развивается в результате хронического
                            воздействия алкоголя
                            на клетки печени. Токсические эффекты алкоголя приводят к жировой дистрофии гепатоцитов,
                            повреждению мембран, активации процессов ПОЛ, развитию аутоиммунных реакций на поврежденные
                            печеночные антигены, стимуляции коллагеногенеза. В зависимости от морфологических изменений
                            АБП включает следующие стадии: алкогольный стеатоз печени, алкогольный стеатогепатит,
                            алкогольный цирроз печени [59]. Множественные эффекты УДХК (холеретический,
                            гепатопротективный, мембраностабилизирующий) используются в лечении АБП на различных стадиях
                            болезни, однако ведущая роль, по данным литературы, принадлежит антиоксидантным,
                            противовоспалительным и антифибротическим эффектам УДХК [32, 60–64]. В экс­пе­ри­мен­тальной
                            модели показано, что назначение УДХК предотвращало повреждение мембран митохондрий и
                            уменьшало этанол-индуцированный стеатоз в культурах клеток [63], а заблаговременное
                            назначение конъюгата УДХК — тауро-<br>
                            УДХК препятствовало этанол-индуцированному окислению липидов и белков, особенно в
                            митохондриях [64].<br>
                            Вирусные гепатиты В и С — это воспалительные заболевания печени, вызванные присутствием
                            соответствующих вирусов. В основе развития этих заболеваний лежат нек­роз гепатоцитов,
                            воспаление печеночной паренхимы с дальнейшим развитием фиброза и возможным исходом в цирроз
                            и гепатоцеллюлярную карциному [65]. В лечении вирусных гепатитов УДХК играет роль
                            гепатопротектора, оказывая мембраностабилизирующее действие и защищая клеточную мембрану
                            гепатоцитов от детергентного действия токсичных ЖК, накапливающихся в печени в результате
                            цитолиза. Она также препятствует апоптозу гепатоцитов, оказывает иммуномодулирующее и
                            антиоксидантное действие [66].<br>
                            Неалкогольная жировая болезнь печени (НАЖБП) — это состояние, характеризующееся чрезмерным
                            отложением жира в печени (более 5%), ассоциированным<br>
                            с инсулинорезистентностью [67]. Спектр поражений печени при НАЖБП включает в себя: стеатоз
                            печени, стеатогепатит, цирроз печени с возможным исходом в рак [68].<br>
                            Тесная связь НАЖБП с ожирением позволяет рассматривать ее как поражение печени при
                            метаболическом синдроме. Однако печень не только является органом-мишенью, но и сама
                            усиливает метаболические нарушения при инсулинорезистентности [69].<br>
                            Ведущим механизмом повреждения печени при НАЖБП считается нарушение утилизации жирных кислот
                            в результате гиперинсулинемии, приводящее к активации процессов ПОЛ, оксидативному стрессу,
                            высвобождению провоспалительных медиаторов с дальнейшей гибелью гепатоцитов по механизму
                            апоптоза или некроза, развитием воспалительной инфильтрации и фиброзом печени [67, 68,
                            70].<br>
                            Помимо уже описанных антиоксидантного, противовоспалительного, антиапоптотического, и
                            антифибротического эффектов УДХК, в лечении НАЖБП ведущую роль играет ее
                            гипохолестеринемический эффект. Показано, что назначение УДХК пациентам с НАЖБП приводит к
                            снижению уровня общего сывороточного холестерина, липопротеинов низкой плотности (ЛПНП-ХС),
                            свободных жирных кислот в крови и повышению уровня липопротеинов высокой плотности
                            (ЛПВП-ХС), уменьшению толщины интимы каротидной артерии. Также показано влияние УДХК на
                            обмен холестерина и ЖК в печени и висцеральной жировой ткани [71, 72].<br>
                            В комплексной терапии больных <strong>циррозом печени различной этиологии</strong> УДХК
                            может использоваться
                            в связи с выявленными антифибротическими свойствами [24–26].<br>
                            В связи с выраженными гипохолестеринемическими и литолитическими свойствами УДХК
                            (способностью значительно снижать содержание холестерина в желчи и увеличивать ее
                            реологические свойства) [14, 27–31] она нашла широкое применение у пациентов с
                            желчнокаменной болезнью (ЖКБ) для растворения холестериновых камней.<br>
                            Назначение УДХК целесообразно при <strong>дискинезии желчевыводящих путей</strong> (ДЖВП).
                            Прогрессированию
                            процессов холелитиаза способствует также билиарная дисфункция в виде гипотонии желчного
                            пузыря и гипертонуса сфинктера Одди [73]. В экспериментальных работах показана не только
                            способность УДХК снижать насыщение желчи холестерином, но и способность увеличивать
                            сократимость желчного пузыря, а также подавлять процессы ПОЛ и воспаления (снижать уровень
                            простагландина E2 и каталазную активность) в мышечных клетках желчного пузыря, предотвращая
                            холецистит у больных с ЖКБ [15].<br>
                            УДХК также показала свою эффективность при холестатических формах лекарственного поражения
                            печени [74]. Также в связи с активирующим влиянием УДХК на целый ряд цитохромов и белков она
                            способна различным образом влиять на метаболизм ксенобиотиков [20, 53]. В экспериментальных
                            работах показано специфическое действие УДХК на поражение печени, вызванное различными
                            токсическими веществами. Так, она не проявляла гепатопротективных свойств при поражении
                            печени, вызванном ССl4 и ацетаминофеном с этиловым спиртом в различных сочетаниях, однако
                            обладает выраженными гепатопротективными свойствами в отношении поражений печени, вызванных
                            амоксициллином и клавулановой кислотой, изониазидом в сочетании с рифампицином и
                            цефтриаксоном, проявляя антиоксидантные и антиапоптотические эффекты [75–77]. Известно, что
                            аторвастатин, который используется при дислипидемии, в т. ч. в сочетании с НАЖБ,
                            метаболизируется с участием цитохрома CYP3A4, индуктором которого может служить УДХК
                            [78].<br>
                            Лечебные эффекты УДХК при <strong>билиарном рефлюкс-эзофагите и рефлюкс-гастрите</strong>
                            основаны на
                            заместительном эффекте УДХК в пуле ЖК, а следовательно, на снижении токсичности желчи. Таким
                            образом, УДХК проявляет цитопротективные свойства в отношении эпителия ЖКТ [16, 17],
                            противовоспалительные свойства (уменьшает мононуклеарный воспалительный инфильтрат в
                            антральном отделе желудка) [79], антиоксидантный и антиапоптотический эффекты [80],
                            возможно, воздействует на эпидермальный фактор роста слизистой оболочки желудка, а значит, и
                            на скорость заживления слизистой оболочки [81]. Вышеописанные эффекты нашли отражение в
                            использовании УДХК при лечении билиарного рефлюкс-гастрита, в т. ч. у пациентов после
                            холецистэктомии [81, 82], эрозивного рефлюкс-эзофагита у больных после гастрэктомии или
                            резекции желудка [83, 84].<br>
                            В настоящее время на рынке существует множество зарубежных препаратов УДХК. В 2010 г. «АО
                            «ФП Оболенское» был представлен отечественный препарат на основе УДХК — Урдокса. Урдокса
                            производится из европейской субстанции (Industria Chimica Emiliana) по стандартам GMP.
                            Урдокса предназначена для лечения заболеваний печени и желчевыводящих путей, является
                            «золотой серединой» среди препаратов УДХК, поскольку сочетает в себе высокое качество
                            итальянской субстанции и наиболее доступную стоимость курса лечения. Высокое качество
                            субстанции УДХК в Урдоксе обеспечивает терапевтическую эффективность при низком риске
                            побочных эффектов, а доступная стоимость курса — высокую приверженность пациентов лечению.
                            Каждая капсула содержит 250 мг УДХК. Восьмилетний опыт применения Урдоксы позволил оценить
                            его эффективность в лечении гепатобилиарной патологии.<br>
                            Препарат Урдокса показал свою эффективность в лечении 32 больных хроническим вирусным
                            гепатитом В и С с синдромами цитолиза и холестаза. Препарат применялся в течение 12 нед. в
                            дозировке 2–4 капсулы в день в виде монотерапии или в комплексной терапии у больных, у
                            которых на фоне противовирусного лечения сохранялись синдромы цитолиза и холестаза. На фоне
                            лечения произошло достоверное снижение уровня трансаминаз, билирубина и
                            γ-глутамилтрансферазы при хорошей переносимости и отсутствии побочных эффектов [85].<br>
                            Препарат Урдокса был эффективен в лечении НАЖБП, ассоциированной с метаболическим синдромом
                            у 21 пациента, в дозе 15 мг/кг/сут в течение 2 мес. Контрольную группу составили 15
                            пациентов, получавших гепатопротектор на основе экстракта листьев артишока в дозировке 0,380
                            г/сут в течение 2 мес. У пациентов основной группы по сравнению с контрольной было отмечено
                            достоверное снижение уровня аланинаминотрансферазы (АЛТ) аспартатаминотрансферазы (АСТ),
                            количества жировой ткани в печени с тенденцией к нормализации липидограммы и снижению
                            индекса массы тела. Наблюдалась гармонизация кишечного микробиоценоза: увеличение количества
                            Bifidobacterium spp., Lactobacillus spp.<br>
                            и Enterococcus spp., повышение уровня метаболитов Bifidobacterium spp., Lactobacillus spp.
                            на фоне снижения уровня микробных эндотоксинов и общей микробной<br>
                            нагрузки [86].<br>
                            Была также доказана роль препарата Урдокса в эндотелиальной коррекции у больных НАЖБП. В
                            исследовании принимали участие 53 человека. 1-ю группу составили 15 пациентов с жировым
                            гепатозом, которые получалимонотерапию метформином в суточной дозировке 1000 мг в течение 6
                            мес. 2-я группа была представлена 16 больными неалкогольным стеатогепатитом (НАСГ),
                            получавшими метформин в суточной дозировке 1000 мг в течение 6 мес. вместе с эссенциальными
                            фосфолипидами (ЭФЛ) в стандартной дозировке. 3-я группа состояла из 16 пациентов с НАСГ,
                            которым были назначены метформин 1000 мг и Урдокса в дозировке 15 мг/кг в течение 6 мес.<br>
                            В результате лечения в 3-й группе были выявлены достоверное увеличение диаметра плечевой
                            артерии (р<0,005), что является следствием вазодилатирующего действия УДХК, а также
                            улучшение релаксирующей функции сосудов за счет показателей эндотелий-зависимой
                            вазодилатации. Отмечалась достоверная регрессия показателей фиброза и активности (по
                            результатам «Фибро/АктиТеста»), причем у лиц со стадией фиброза F1 и минимальной активностью
                            некровоспалительного процесса в ткани печени наблюдалась нормализация показателей. У
                            пациентов 3-й группы с портальным фиброзом, наличием септ и умеренной степенью активности
                            процесса в результате терапии с включением Урдоксы отмечались достоверное улучшение функции
                            эндотелия, а также уменьшение признаков воспаления и фиброза по данным «Фибро/АктиТеста». У
                            больных 3-й группы с фиброзом F3 и высокой степенью активности процесса применение Урдоксы в
                            комплексной терапии привело к достоверному улучшению показателей «Фибро/АктиТеста». У
                            больных, получавших метформин и ЭФЛ, существенного улучшения показателей не выявлено
                            [87].<br>
                            Применение препарата Урдокса в дозе 500 мг/сут в течение 4 нед. у 50 больных циррозом печени
                            различной этиологии (вирусной, алкогольной, неуточненной) в стадии суб- и декомпенсации
                            совместно с дезинтоксикационной терапией привело к уменьшению клинических симптомов
                            заболевания и достоверному улучшению биохимических показателей цитолиза и холестаза
                            [88].<br>
                            Препарат Урдокса в дозировке 10 мг/кг в течение 3 мес. исследовался у 58 пациенток с ЖКБ
                            (билиарным сладжем (БС)). Из них у 11 наблюдался микролитиаз желчного пузыря, у 38 — сгустки
                            замазкообразной желчи, у 9 имелось сочетание микролитиаза со сгустками замазкообразной
                            желчи. Спустя 3 мес. урсотерапии по данным УЗИ отмечено исчезновение БС у 50 пациенток
                            (86,2%). У оставшихся 8 пациенток исчезновение БС наблюдалось через 2 мес. дополнительной
                            терапии препаратом Урдокса в дозе 15 мг/кг [89]. Клинически доказано, что Урдокса не только
                            устраняет БС, но и значительно уменьшает моторные нарушения желчевыводящих путей,
                            проявляющиеся тяжестью или болями в эпигастрии или правом подреберье, горечью во рту,
                            тошнотой, отрыжкой, изжогой, метеоризмом [73, 90].<br>
                            Клинически показано, что совместное назначение атор­вастатина и Урдоксы не только приводит к
                            более выраженному гиполипидемическому действию, но и препятствует лекарственному
                            (статиновому) поражению печени. В исследовании принимали участие 196 пациентов с НАЖБП и
                            дислипидемией (повышение уровня общего холестерина (ХС) и триглицеридов (ТГ), не
                            корригируемое диетой на протяжении 3 мес.). В 1-ю группу входили пациенты с дислипидемией и
                            НАЖБП в стадии жирового гепатоза, во 2-ю группу — пациенты с дислипидемией и НАЖБП в стадии
                            НАСГ. Все пациенты принимали аторвастатин и ЭФЛ. Дополнительное назначение Урдоксы в 1-й
                            группе в дозе 15 мг/кг/сут (в отличие от пациентов, не получавших Урдоксу) препятствовало
                            нарастанию уровня трансаминаз и способствовало более быстрому и выраженному снижению уровня
                            общего холестерина. Дополнительное назначение Урдоксы во 2-й группе в дозе 17 мг/кг/сут
                            привело к достоверному существенному снижению показателей цитолиза и холестаза, а также
                            уровня ТГ и ХС [91].<br>
                            Таким образом, препарат Урдокса был эффективен в лечении заболеваний органов гепатобилиарной
                            зоны. Он показал гепатопротективный (цитопротективный) и антихолестатический эффекты
                            (устранял синдромы цитолиза и холестаза), литолитический эффект, а также улучшал моторику
                            желчевыводящих путей (устранял БС и клинические проявления ДЖВП), продемонстрировал
                            гипохолестеринемический эффект (нормализовал показатели липидограммы) и проявил себя как
                            эндотелиальный корректор. Препарат Урдокса проявил антифибротические свойства (улучшал
                            показатели «Фибро/АктиТеста») и был эффективен в профилактике статиновых гепатитов.</p>
                        <p>Литература</p>
                        <p>1. Минушкин О. Н. Урсодезоксихолевая кислота (Урсосан) в практике терапевта и
                            гастроэнтеролога. Методическое пособие. М.: Медицина, 2009. 20 с. [Minushkin O. N.
                            Ursodezoksikholevaya kislota (Ursosan) v praktike terapevta i gastroenterologa.
                            Metodicheskoye posobiye. M.: Meditsina, 2009. 20 s. (in Russian)].
                            <br>2. Ильченко А. А. Желчные кислоты в норме и при патологии // Экспериментальная и
                            клиническая гастроэнтерология. 2010. № 4. С. 2–13 [Il’chenko A. A. Zhelchnyye kisloty v
                            norme i pri patologii // Eksperimental’naya i klinicheskaya gastroenterologiya. 2010. № 4.
                            S. 2–13 (in Russian)].
                            <br>3. Sokol R. J., Devereaux M., Khandwala R. et al. Evidence for involvement of oxygen
                            free radicals in bile acid toxicity to isolated rat hepatocytes // Hepatology. 1993. Vol.
                            17. P. 869–881.
                            <br>4. Faubion W. A., Guicciardi M. E., Miyoshi H. et al. Toxic bile salts induce rodent
                            hepatocyte apoptosis via direct activation of Fas // J Clin Invest. 1999. Vol. 103. P.
                            137–145.
                            <br>5. Cai S. Y., Boyer J. L. The Role of Inflammation in the Mechanisms of Bile
                            Acid-Induced Liver Damage // Digestive Diseases. 2017. Vol. 35 (3). P. 232–234.
                            <br>6. Oizumi K., Sekine S., Fukagai M. et al. Identification of Bile Acids Responsible for
                            Inhibiting the Bile Salt Export Pump, Leading to Bile Acid Accumulation and Cell Toxicity in
                            Rat Hepatocytes // J Pharm Sci. 2017. Vol. 106 (9). P. 2412–2419.
                            <br>7. Trauner M., Graziadei I. W. Review article: mechanisms of action and therapeutic
                            applicationsof ursodeoxycholic acid in chronic liver diseases // Aliment Pharmacol Ther.
                            1999. Vol. 13 (8). P. 979–995.
                            <br>8. Махов В. М., Угрюмова Л. Н., Балахонов А. А., Мамиева З. А. Урсодезоксихолевая
                            кислота: взгляд терапевта // Медицинский совет. 2017. № 5. С. 112–116 [Makhov V.M.,
                            Ugryumova L. N., Balakhonov A. A., Mamiyeva Z. A. Ursodezoksikholevaya kislota: vzglyad
                            terapevta // Meditsinskiy sovet. 2017. № 5. S. 112–116 (in Russian)].
                            <br>9. Banerjee B., Shaheen N. J., Martinez J. A. et al. Clinical Study of Ursodeoxycholic
                            Acid in Barrett’s Esophagus Patients // Cancer Prev Res (Phila). 2016. Vol. 9 (7). P.
                            528–533.
                            <br>10. Stiehl A., Rudolph G., Raedsch R. et al. Ursodeoxycholic acid–induced changes of
                            plasma and urinary bile acids in patients with primary biliary cirrhosis // Hepatology.
                            1990. Vol. 12 (3). P. 492–497.
                            <br>11. Guldutuna S., Leuschner M., Wunderlich N. et al. Cholic acid and ursodeoxycholic
                            acid therapy in primary biliary cirrhosis. Changes in bile acid patterns and their
                            correlation with liver function // Eur J Clin Pharmacol. 1993. Vol. 45 (3). P. 221–225.
                            <br>12. Fujita K., Iguchi Y., Une M., Watanabe S. Ursodeoxycholic Acid Suppresses
                            Lipogenesis in Mouse Liver: Possible Role of the Decrease in β-Muricholic Acid, a Farnesoid
                            X Receptor Antagonist // Lipids. 2017. Vol. 52 (4). P. 335–344.
                            <br>13. Вовк Е. И. Молекулярные механизмы токсичности и побочных эффектов урсодезоксихолевой
                            кислоты: замедление регенерации и индукция состояния клеточного покоя // РМЖ. 2014. № 15. С.
                            1120–1129 [Vovk Ye.I. Molekulyarnyye mekhanizmy toksichnosti i pobochnykh effektov
                            ursodezoksikholevoy kisloty: zamedleniye regeneratsii i induktsiya sostoyaniya kletochnogo
                            pokoya // RMZH. 2014. № 15. S. 1120–1129 (in Russian)].
                            <br>14. Морозов C. В., Кучерявый Ю. А. Гепатопротекторы в клинической практике: рациональные
                            аспекты использования. Пособие для врачей. М.: 4ТЕ Арт. 2011. 28 c. [Morozov C.V.,
                            Kucheryavyy YU.A. Gepatoprotektory v klinicheskoy praktike: ratsional’nyye aspekty
                            ispol’zovaniya. Posobiye dlya vrachey. M.: 4TE Art. 2011. 28 s. (in Russian)].
                            <br>15. Guarino M. P.L., Cong P., Cicala M. et al. Ursodeoxycholic acid improves muscle
                            contractility and inflammation in symptomatic gallbladders with cholesterol gallstones //
                            Gut. 2007. Vol. 56 (6). P. 815–820.
                            <br>16. Селезнева Э. Я., Ильченко А. А., Чикунова Б. З. Цитопротективный эффект
                            урсодезоксихолевой кислоты на слизистую оболочку органов гастродуоденальной зоны у больных
                            пожилого возраста с сочетанием желчнокаменной болезни и язвенной болезни двенадцатиперстной
                            кишки // ЭИКГ. 2011. № 4. С. 44–48 [Selezneva E.YA., Il’chenko A.A., Chikunova B. Z.
                            Tsitoprotektivnyy effekt ursodeoksikholevoy kisloty na slizistuyu obolochku organov
                            gastroduodenal’noy zony u bol’nykh pozhilogo vozrasta s sochetaniyem zhelchnokamennoy
                            bolezni i yazvennoy bolezni dvenadtsatiperstnoy kishki // EIKG. 2011. № 4. S. 44–48 (in
                            Russian)].
                            <br>17. Ильченко А. А., Богатырева О. Е., Шибаева Л. О. и др. Урсодезоксихолевая кислота.
                            Клинико-морфологическое исследование при желчнокаменной болезни, сочетающейся с
                            эрозивно-язвенными поражениями гастродуоденальной зоны // Южно-рос. мед. журн. 2002. № 1. С.
                            48–53 [Il’chenko A.A., Bogatyreva O. Ye., Shibayeva L. O. i dr. Ursodezoksikholevaya
                            kislota. Kliniko-morfologicheskoye issledovaniye pri zhelchnokamennoy bolezni,
                            sochetayushcheysya s erozivno-yazvennymi porazheniyami gastroduodenal’noy zony //
                            Yuzhno-ros. med. zhurn. 2002. № 1. S. 48–53 (in Russian)].
                            <br>18. Munoz-Garrido P., Marin J. J. Ursodeoxycholic acid inhibits hepatic cystogenesis in
                            experimental models of polycystic liver disease // J Hepatol. 2015. Vol. 63 (4). P. 952–961.
                            <br>19. Guldutuna S., Zimmer G., Imhof M. et al. Molecular aspects of membrane stabilization
                            by ursodeoxycholate // Gastroenterology. 1993. Vol. 104 (6). P. 1736–1744.
                            <br>20. Kotb M. A. Molecular Mechanisms of Ursodeoxycholic Acid Toxicity and Side Effects:
                            Ursodeoxycholic Acid Freezes Regeneration and Induces Hibernation Mode // Int J Mol Sci.
                            2012. Vol. 13 (7). P. 8882–8914.
                            <br>21. Calmus Y., Gane P., Rouger P., Poupon R. Hepatic expression of class I and class II
                            histocompatibility complex molecules in primary biliary cirrhosis: Effect of ursodeoxycholic
                            acid // Hepatology. 1990. Vol. 11. Р.12–15.
                            <br>22. Yoshikawa M., Tsujii T., Matsumura K. et al. Immunomodulatory effects of
                            ursodeoxycholic acid on immune responses // Hepatology. 1992. Vol. 16. Р. 358–364.
                            <br>23. Ko W. K., Lee S. H., Kim S. J. et al. Anti-inflammatory effects of ursodeoxycholic
                            acid by lipopolysaccharide-stimulated inflammatory responses in RAW 264.7 macrophages //
                            PLoS One. 2017. Vol. 12 (6). P. 1–12.
                            <br>24. Peterson T. C., Slysz G., Isbrucker R. The inhibitory effect of ursodeoxycholic acid
                            and pentoxifylline on platelet derived growth factor-stimulated proliferation is distinct
                            from an effect by cyclic AMP // Immunopharmacology. 1998. Vol. 39 (3). P. 181–191.
                            <br>25. Rockey D. C. Current and Future Anti-fibrotic Therapies for Chronic Liver Disease //
                            Clin Liver Dis. 2008. Vol. 12 (4). P. 939–962.
                            <br>26. Cohen-Naftaly M. Current status of novel antifibrotic therapies in patients with
                            chronic liver disease // Therap Adv Gastroenterol. 2011. Vol. 4 (6). P. 391–417.
                            <br>27. Einarsson K. Effect of ursodeoxycholic acid on hepatic cholesterol metabolism //
                            Scand J Gastroenterol Suppl. 1994. Vol. 204. P. 19–23.
                            <br>28. Angelin B., Ewerth S., Einarsson K. Ursodeoxycholic acid treatment in cholesterol
                            gallstone disease: effects on hepatic 3-hydroxy-3-methylglutaryl coenzyme A reductase
                            activity, biliary lipid composition, and plasma lipid levels // Journal of Lipid Research
                            1983. Vol. 24. P. 461–468.
                            <br>29. Hirabayashi N., Osuga T. Effect of ursodeoxycholic acid on hepatic HMG CoA reductase
                            and cholesterol 7 α hydroxylase of rat in vitro // Pharmacometrics 1978. Vol. 15 (1). P.
                            125–132.
                            <br>30. Crestani M., De Fabiani E., Malavasi B. et al. Effect of natural and structurally
                            modified bile acids on cholesterol metabolizing enzymes in rat liver microsomes // Chem Phys
                            Lipids. 1989. Vol. 51 (2). P. 119–126.
                            <br>31. Abate N., Carubbi F., Bozzoli M. Effect of chenodeoxycholic acid and ursodeoxycholic
                            acid administration on acyl-CoA: cholesterol acyltransferase activity in human liver // Ital
                            J Gastroenterol. 1994. Vol. 26 (6). P. 287–293.
                            <br>32. Lukivskaya O., Zavodnik L., Knas M., Buko V. Antioxidant mechanism of
                            hepatoprotection by ursodeoxycholic acid in experimental alcoholic steatohepatitis // Adv
                            Med Sci. 2006. Vol. 51. P. 54–59.
                            <br>33. Pemberton P. W., Aboutwerat A., Smith A., Warnes T. W. Ursodeoxycholic acid in
                            primary biliary cirrhosis improves glutathione status but fails to reduce lipid peroxidation
                            // Redox. Rep. 2006. Vol. 11. Р. 117–123.
                            <br>34. Marzioni M., Francis H., Benedetti A. et al. Ca2+-dependent cytoprotective effects
                            of ursodeoxycholic and tauroursodeoxycholic acid on the biliary epithelium in a rat model of
                            cholestasis and loss of bile ducts // Am J Pathol. 2006. Vol. 168 (2). P. 398–409.
                            <br>35. Sola S., Ma X., Castro R. E. et al. Ursodeoxycholic acid modulates E2F-1 and p53
                            expression through a caspase-independent mechanism in transforming growth factor
                            beta1-induced apoptosis of rat hepatocytes // J Biol Chem. 2003. Vol. 278 (49). P.
                            48831–48838.
                            <br>36. Castro R. E., Amaral J. D., Sola S. et al. Differential regulation of cyclin D1 and
                            cell death by bile acids in primary rat hepatocytes // Am J Physiol Gastrointest Liver
                            Physiol. 2007. Vol. 293 (1). P. 327–334.
                            <br>37. Sola S., Aranha M. M., Steer C. J., Rodrigues C. M. Game and players: mitochondrial
                            apoptosis and the therapeutic potential of ursodeoxycholic acid // Curr Issues Mol Biol.
                            2007. Vol. 9 (2). P. 123–138.
                            <br>38. Rodrigues C. M., Fan G., Ma X. et al. A novel role for ursodeoxycholic acid in
                            inhibiting apoptosis by modulating mitochondrial membrane perturbation // J Clin Invest.
                            1998. Vol. 101 (12). P. 2790–2799.
                            <br>39. Peiro-Jordan R. Investigation of the antiproliferative mechanisms of the
                            chemopreventive agent ursodeoxycholic acid (UDCA) in vitro. Berlin. 2011. 120 p.
                            <br>40. Miura T., Ouchida R., Yoshikawa N. et al. Functional modulation of the
                            glucocorticoid receptor and suppression of NF-kappaB-dependent transcription by
                            ursodeoxycholic acid // J Biol Chem. 2001. Vol. 276. Р. 47371–47378.
                            <br>41. Fedorowski T., Salen G., Tint G. S., Mosbach E. Transformation of chenodeoxycholic
                            acid and ursodeoxycholic acid by human intestinal bacteria // Gastroenterology. 1979. Vol.
                            77. Р. 1068–1073.
                            <br>42. Bazzoli F., Fromm H., Sarva R. P. et al. Comparative formation of lithocholic acid
                            from chenodeoxycholic and ursodeoxycholic acids in the colon // Gastroenterology. 1982. Vol.
                            83. Р. 753–760.
                            <br>43. Thistle J. L., Larusso N. F., Hofmann A. F. et al. Differing effects of
                            ursodeoxycholic or chenodeoxycholic acid on biliary cholesterol saturation and bile acid
                            metabolism in man. A dose-response study // Dig Dis Sci. 1982. Vol. 27. Р. 161–168.
                            <br>44. Sinakos E., Marschall H.– U., Kowdley K. V. et al. Bile acid changes after high-dose
                            ursodeoxycholic acid treatment in primary sclerosing cholangitis: Relation to disease
                            progression // Hepatology. 2010. Vol. 52. Р. 197–203.
                            <br>45. Powell A. A., Akare S., Qi W. et al. Resistance to ursodeoxycholic acid-induced
                            growth arrest can also result in resistance to deoxycholic acid-induced apoptosis and
                            increased tumorgenicity // BMC Cancer. 2006. Vol. 6. P. 219.
                            <br>46. Garewal H., Bernstein H., Bernstein C. et al. Reduced bile acid-induced apoptosis in
                            “normal” colorectal mucosa: A potential biological marker for cancer risk // Cancer Res.
                            1996. Vol. 56. Р. 1480–1483.
                            <br>47. Sola S., Ma X., Castro R. E. et al. Ursodeoxycholic acid modulates E2F-1 and p53
                            expression through a caspase-independent mechanism in transforming growth factor
                            beta1-induced apoptosis of rat hepatocytes // J Biol Chem. 2003. Vol. 278 (49). P.
                            48831–48838.
                            <br>48. Garg A., Aggarwal B. B. Nuclear transcription factor-kappaB as a target for cancer
                            drug Development // Leukemia. 2002. Vol. 16. Р.1053–1068.
                            <br>49. Tsagarakis N. J., Drygiannakis I., Batistakis A. G. et al. A concentration-dependent
                            effect of ursodeoxycholate on apoptosis and caspases activities of HepG2 hepatocellular
                            carcinoma cells // Eur J Pharmacol. 2010. Vol. 640 (1–3). P. 1–7.
                            <br>50. Goode E. C., Rushbrook S. M. A review of the medical treatment of primary sclerosing
                            cholangitis in the 21st century // Ther Adv Chronic Dis. 2016. Vol. 7 (1). P. 68–85.
                            <br>51. Ikegami T., Matsuzaki Y., Fukushima S. et al. Suppressive effect of ursodeoxycholic
                            acid on type IIA phospholipase A2 expression in HepG2 Cells // Hepatology. 2005. Vol. 41. Р.
                            896–905.
                            <br>52. Weitzel C., Stark D., Kullmann F. et al. Ursodeoxycholic acid induced activation of
                            the glucocorticoid receptor in primary rat hepatocytes // Eur J Gastroenterol. Hepatol.
                            2005. Vol. 17. Р. 169–177.
                            <br>53. Paolini M., Pozzetti L., Montagnani M. et al. Ursodeoxycholic acid (UDCA) prevents
                            DCA effects on male mouse liver via up-regulation of CYP [correction of CXP] and
                            preservation of BSEP activities // Hepatology. 2002. Vol. 36. Р. 305–314.
                            <br>54. Beuers U., Trauner M., Jansen P., Poupon R. New paradigms in the treatment of
                            hepatic cholestasis: from UDCA to FXR, PXR and beyond // J Hepatol. 2015. Vol. 62. P. 25–37.
                            <br>55. Hirschfield G. M., Beuers U., Corpechot C. et al. EASL Clinical Practice Guidelines:
                            The diagnosis and management of patients with primary biliary cholangitis // J Hepatol.
                            2017. Vol. 67. P. 145–172.
                            <br>56. Beuers U., Boberg K. M., Chapman R. W. et al. EASL Clinical Practice Guidelines:
                            Management of cholestatic liver diseases // J Hepatol. 2009. Vol. 51. P. 237–267.
                            <br>57. Keith D., Lindor M. D. ACG Clinical Guideline: Primary Sclerosing Cholangitis // The
                            American Journal of Gastroenterology. 2015. Vol. 110. P. 646–659.
                            <br>58. Tabibian J. H., Lindor K. D. Ursodeoxycholic Acid in Primary Sclerosing Cholangitis:
                            If Withdrawal Is Bad, Then Administration Is Good (Right?) // Hepatology. 2014. Vol. 60 (3).
                            Р. 785–788.
                            <br>59. Минушкин О. Н., Масловский Л. В. Лечение алкогольной болезни печени с использованием
                            Эссенциале форте Н // Лечебное дело. 2015. № 3. С. 82–85 [Minushkin O.N., Maslovskiy L. V.
                            Lecheniye alkogol’noy bolezni pecheni s ispol’zovaniyem Essentsiale forte N // Lechebnoye
                            delo. 2015. № 3. S. 82–85 (in Russian)].
                            <br>60. Preobrazhenskij V. N., Taianovskij V. Iu. Efficacy of ursodeoxycholic acid (UDCA) in
                            the treatment of chronic alcoholic hepatitis // Klin Med (Mosk). 1998. Vol. 76 (5). P.
                            26–28.
                            <br>61. Hamed R., Ahmed H. Effect of ursodeoxycholic (UDCA) acid on fibrogenolysis markers
                            in alcoholic liver disease in man // Hepatology J Liver. 2017. Vol. 6 (2). (Suppl). P. 70.
                            <br>62. Маев И., Дичева Д., Андреев Д., Пенкина Т. Урсодезоксихолевая кислота в терапии
                            алкогольной болезни печени // Врач. 2012. № 10. С. 52–55 [Mayev I., Dicheva D., Andreyev D.,
                            Penkina T. Ursodezoksikholevaya kislota v terapii alkogol’noy bolezni pecheni // Vrach.
                            2012. № 10. S. 52–55 (in Russian)].
                            <br>63. Neuman M. G., Cameron R. G., Shear N. H. et al. Effect of tauroursodeoxycholic and
                            ursodeoxycholic acid on ethanol-induced cell injuries in the human Hep G2 cell line //
                            Article Gastroenterology. 1995. Vol. 109. P. 555–563.
                            <br>64. Vendemiale G., Grattagliano I., Signorile A., Altomare E. Ethanol-induced changes of
                            intracellular thiol compartmentation and protein redox status in the rat liver: Effect of
                            tauroursodeoxycholate // J Hepatol. 1998. Vol. 28 (1). P. 46–53.
                            <br>65. Ивашкин В. Т., Ющук Н. Д. Рекомендации по диагностике и лечению взрослых больных
                            гепатитом С. М., 2014. 80 с. [Ivashkin V.T., Yushchuk N. D. Rekomendatsii po diagnostike i
                            lecheniyu vzroslykh bol’nykh gepatitom S. M., 2014. 80 s. (in Russian)].
                            <br>66. Wijaya I. The role of ursodeoxycholic acid in acute viral hepatitis: an EBCR // Acta
                            Med Indones. 2015. Vol. 47 (4). Р. 352–357.
                            <br>67. Marchesini G., Day Ch.P., Dufour J. F. et al. EASL–EASD–EASO Clinical Practice
                            Guidelines for the management of non-alcoholic fatty liver disease // J Hepatol. 2016. Vol.
                            64 (6). P. 1388–1402.
                            <br>68. Казюлин А. Н. Место урсодезоксихолевой кислоты в терапии неалкогольной жировой
                            болезни печени на разных стадиях заболевания: стеатоз, стеатогепатит, фиброз/цирроз // РМЖ.
                            2017. № 17. С. 1248–1257 [Kazyulin A. N. Mesto ursodezoksikholevoy kisloty v terapii
                            nealkogol’noy zhirovoy bolezni pecheni na raznykh stadiyakh zabolevaniya: steatoz,
                            steatogepatit, fibroz/tsirroz // RMZH. 2017. № 17. S. 1248–1257 (in Russian)].
                            <br>69. Мельниченко Г. А., Елисеева А. Ю., Маевская М. В. Распространенность неалкогольной
                            жировой болезни печени при ожирении и ее взаимосвязь с факторами риска сердечно-сосудистых
                            заболеваний и сахарного диабета 2-го типа // РЖГГК. 2012. № 2. С. 45–52 [Mel’nichenko G.A.,
                            Yeliseyeva A.YU., Mayevskaya M. V. Rasprostranennost’ nealkogol’noy zhirovoy bolezni pecheni
                            pri ozhirenii i yeye vzaimosvyaz’ s faktorami riska serdechno-sosudistykh zabolevaniy i
                            sakharnogo diabeta 2-go tipa // RZHGGK. 2012. № 2. S. 45–52 (in Russian)].
                            <br>70. Диагностика и лечение неалкогольной жировой болезни печени / под ред. Ивашкина В. Т.
                            РОПИП. М., 2015. 29 с. [Diagnostika i lecheniye nealkogol’noy zhirovoy bolezni pecheni / Pod
                            red. Ivashkina V. T. ROPIP. M., 2015. 29 s. (in Russian)].
                            <br>71. Mueller M., Thorell A., Claude T. Ursodeoxycholic acid exerts farnesoid X
                            receptor-antagonistic effects on bile acid and lipid metabolism in morbid obesity // J
                            Hepatol. 2015. Vol. 62 (6). P. 1398–1404.
                            <br>72. Ozel Coskun B. D., Yucesoy M., Gursoy S. et al. Effects of ursodeoxycholic acid
                            therapy on carotid intima media thickness, apolipoprotein A1, apolipoprotein B, and
                            apolipoprotein B/A1 ratio in nonalcoholic steatohepatitis // Eur J Gastroenterol Hepatol.
                            2015. Vol. 27 (2). P. 142–149.
                            <br>73. Минушкин О. Н., Елизаветина Г. А., Иванова О. И., Шапошникова О. Ф.
                            Урсодезоксихолевая кислота в лечении больных с билиарным сладжем // ЭФ. Гастроэнтерология.
                            2012. № 3. С. 10–12 [Minushkin O.N., Yelizavetina G. A., Ivanova O. I., Shaposhnikova O. F.
                            Ursodezoksikholevaya kislota v lechenii bol’nykh s biliarnym sladzhem // EF.
                            Gastroenterologiya. 2012. № 3. S. 10–12 (in Russian)].
                            <br>74. Khoury T., Rmeileh A. A., Yosha L. Drug Induced Liver Injury: Review with a Focus on
                            Genetic Factors, Tissue Diagnosis, and Treatment Options // J Clin Transl Hepatol. 2015.
                            Vol. 3 (2). P. 99–108.
                            <br>75. Alhumaidha K. A., El-Awdan S.A., El-Iraky W.I. et al. Protective effects of
                            ursodeoxycholic acid on ceftriaxone-induced hepatic injury in rats // Bulletin of Faculty of
                            Pharmacy. 2014. Vol. 52 (1). P. 45–50.
                            <br>76. El-Sherbiny G., Taye A., Abdel-Raheem I. Role of ursodeoxycholic acid in prevention
                            of hepatotoxicity caused by amoxicillin-clavulanic acid in rats // Ann Hepatol. 2009. Vol.
                            8. P. 134–140.
                            <br>77. Chen X., Xu J., Zhang C. et al. The protective effects of ursodeoxycholic acid on
                            isoniazid plus rifampicin induced liver injury in mice // Eur J Clin Pharmacol. 2011. Vol.
                            659 (1) P. 53–60.
                            <br>78. Корнеева О. Н., Драпкина О. М. Комбинация урсодезоксихолевой кислоты и
                            аторвастатина: вопросы межлекарственного взаимодействия в лечении пациентов с ожирением и
                            сопутствующей патологией печени // Рос. мед. вести. 2012. № 1. С. 29–33 [Korneyeva O.N.,
                            Drapkina O. M. Kombinatsiya ursodezoksikholevoy kisloty i atorvastatina: voprosy
                            mezhlekarstvennogo vzaimodeystviya v lechenii patsiyentov s ozhireniyem i soputstvuyushchey
                            patologiyey pecheni // Ros. med. vesti. 2012. № 1. S. 29–33 (in Russian)].
                            <br>79. Silva J. G., Zeitune J. M., Sipahi A. M. et al. Ursodeoxycholic acid does not
                            interfere with in vivo Helicobacter pylori colonization // Rev Hosr Clin. 2000. Vol. 55. P.
                            201–206.
                            <br>80. Peng S., Huo X., Rezaei D. et al. In Barrett’s esophagus patients and Barrett’s cell
                            lines, ursodeoxycholic acid increases antioxidant expression and prevents DNA damage by bile
                            acids // Am J Physiol Gastrointest Liver Physiol. 2014. Vol. 307 (2). P. 129–139.
                            <br>81. Ozkaya M., Erten A., Sahin I. et al. The effect of ursodeoxycholic acid treatment on
                            epidermal growth factor in patients with bile reflux gastritis // Turk J Gastroenterol.
                            2002. Vol. 13 (4). P. 198–202.
                            <br>82. Zhao Z. F., Gao H. L., Yao P. Ursodeoxycholic acid for treatment of bile reflux
                            gastritis: a systematic review // World Chinese Journal of Digestology. 2013. Vol. 21 (26).
                            P. 2708–2716.
                            <br>83. Минушкин О. Н., Масловский Л. В., Шулешова А. Г., Назаров Н. С. Лечение больных с
                            рефлюкс-эзофагитом после гастрэктомии или резекции желудка // Клинические перспективы
                            гастроэнтерологии, гепатологии. 2013. № 2. С. 33–40 [Minushkin O.N., Maslovskiy L. V.,
                            Shuleshova A. G., Nazarov N. S. Lecheniye bol’nykh s reflyuks-ezofagitom posle gastrektomii
                            ili rezektsii zheludka // Klinicheskiye perspektivy gastroenterologii, gepatologii. 2013. №
                            2. S. 33–40 (in Russian)].
                            <br>84. Янова О. Б., Васнев О. С., Ким В. А., Кривопусков В. А. Пищевод Баретта у больных
                            после резекции желудка: распространенность и факторы риска // Доктор.Ру. 2014. № 3 (91). С.
                            78–82 [Yanova O.B., Vasnev O. S., Kim V. A., Krivopuskov V. A. Pishchevod Baretta u bol’nykh
                            posle rezektsii zheludka: rasprostranennost’ i faktory riska // Doktor.Ru. 2014. № 3 (91).
                            S.78–82 (in Russian)].
                            <br>85. Эсауленко Е. В., Никитина О. Е. Опыт применения урсодезоксихолевой кислоты (Урдокса)
                            в комплексной терапии хронического вирусного гепатита // Журнал инфектологии. 2011. Т. 3. №
                            3. С. 42–45 [Esaulenko Ye.V., Nikitina O. Ye. Opyt primeneniya ursodezoksikholevoy kisloty
                            (Urdoksa) v kompleksnoy terapii khronicheskogo virusnogo gepatita // Zhurnal infektologii.
                            2011. T. 3. № 3. S. 42–45 (in Russian)].
                            <br>86. Авалуева Е. Б., Ткаченко Е. И., Сказываева Е. В. и др. Эффективность
                            урсодезоксихолевой кислоты в терапии неалкогольной жировой болезни печени, ассоциированной с
                            метаболическим синдромом // Экспериментальная и клиническая гастроэнтерология. 2013. № 11.
                            С. 26–30 [Avaluyeva Ye.B., Tkachenko Ye.I., Skazyvayeva Ye.V. i dr. Effektivnost’
                            ursodezoksikholevoy kisloty v terapii nealkogol’noy zhirovoy bolezni pecheni,
                            assotsiirovannoy s metabolicheskim sindromom // Eksperimental’naya i klinicheskaya
                            gastroenterologiya. 2013. № 11. S. 26–30 (in Russian)].
                            <br>87. Зиновьева Е. Н., Мехтиев С. Н., Соколовский С. В. Эндотелиальная дисфункция как
                            фактор прогрессирования неалкогольного стеатогепатита // Терапевтические подходы.
                            Эффективная фармакотерапия. Гастроэнтерология. 2011. № 2. С. 36–40 [Zinov’yeva Ye.N.,
                            Mekhtiyev S. N., Sokolovskiy S. V. Endotelial’naya disfunktsiya kak faktor progressirovaniya
                            nealkogol’nogo steatogepatita // Terapevticheskiye podkhody. Effektivnaya farmakoterapiya.
                            Gastroenterologiya. 2011. № 2. S. 36–40 (in Russian)].
                            <br>88. Сологуб Т. В., Осиновец О. Ю. Опыт применения препарата Урдокса у больных
                            хроническим гепатитом в стадии цирроза // Terra Medica. 2012. № 2. С. 9–17 [Sologub T.V.,
                            Osinovets O.YU. Opyt primeneniya preparata Urdoksa u bol’nykh khronicheskim gepatitom v
                            stadii tsirroza // Terra Medica. 2012. № 2. S. 9–17 (in Russian)].
                            <br>89. Багишева Н. В., Трухан Д. И., Гришечкина И. А., Бусс Н. Н. Урсодезоксихолевая
                            кислота и итоприда гидрохлорид в лечении билиарного сладжа // Международный журнал
                            экспериментального образования. 2015. № 6. С. 91–92 [Bagisheva N.V., Trukhan D. I.,
                            Grishechkina I. A., Buss N. N. Ursodezoksikholevaya kislota i itoprida gidrokhlorid v
                            lechenii biliarnogo sladzha // Mezhdunarodnyy zhurnal eksperimental’nogo obrazovaniya. 2015.
                            № 6. S. 91–92 (in Russian)].
                            <br>90. Симаненков В. И., Саблин О. А. Возможности применения урсодезоксихолевой кислоты
                            (препарата Урдокса) при дискинезии желчевыводящих путей // Гастроэнтерология
                            Санкт-Петербурга. 2010. № 2–3. С. 23–26 [Simanenkov V.I., Sablin O. A. Vozmozhnosti
                            primeneniya ursodezoksikholevoy kisloty (preparata Urdoksa) pri diskinezii
                            zhelchevyvodyashchikh putey // Gastroenterologiya Sankt-Peterburga 2010. № 2–3. S. 23–26 (in
                            Russian)].
                            <br>91. Зиновьева Е. Н., Мехтиев С. Н., Мехтиева О. А. Современные аспекты патогенетического
                            лечения неалкогольной жировой болезни печени // ЭФ. Гастроэнтерология. 2012. № 4. С. 24–28
                            [Zinov’yeva Ye.N., Mekhtiyev S. N., Mekhtiyeva O. A. Sovremennyye aspekty patogeneticheskogo
                            lecheniya nealkogol’noy zhirovoy bolezni pecheni // EF. Gastroenterologiya. 2012. № 4. S.
                            24–28 (in Russian)].</p>
                        <p style="font-style: italic">Оригинальная статья опубликована на сайте РМЖ (Русский медицинский
                            журнал):
                            https://www.rmj.ru/articles/gastroenterologiya/Ursodezoksiholevaya_kislota_vgastroenterologicheskoy_praktike/#ixzz5QHLDScZS</p>
                    </div>
                </div>
<!--                <a @click="animateScroll" class="more-detail">-->
<!--                    Оставить комментарий → </a>-->
<!--                <br>-->
<!--                <p style="font-size: 11px; color: #909090;">-->
<!--                    <a style="color: #909090; text-decoration: underline"-->
<!--                       href="http://5-clinic.com/category/гастроэнтерология/">Гастроэнтерология</a>,-->
<!--                    <a style="color: #909090; text-decoration: underline"-->
<!--                       href="http://5-clinic.com/category/научная-статья/">Научная статья</a></p>-->
<!--                <div class="divider"></div>-->
<!--                <comment-form id="comment-form" slug="" class="comment-wrapper"/>-->
            </div>

        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";
import CommentForm from "@/components/CommentForm";
import animateScrollTo from "animated-scroll-to";

export default {
    name: "research1",
    components: {
        ContentHeader,
        CommentForm
    },
    methods: {
        animateScroll() {
            animateScrollTo(document.getElementById("comment-form"))
        }
    }
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: flex;
    width: 380px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

.article-detail {
    display: flex;
    margin-top: 30px;

    @media screen and (max-width: 570px) {
        flex-direction: column;
        align-items: flex-start;
    }

    .comment_box {
        width: 100px;
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-direction: column;

        @media screen and(max-width: 570px) {
            flex-direction: row;
            width: 250px;

            .date {
                margin-right: 10px;
            }

            .value, .comments_number {
                margin-top: 0;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .date {
            width: 100%;
            position: relative;
        }

        .date .value {
            background-color: #006688;
            color: #fff;
            padding: 10px 13px;
            font-size: 12px;
            width: 100%;

            @media screen and (max-width: 768px) {
                padding: 10px 10px;
            }
        }

        .arrow_date {
            content: '';
            top: 0;
            right: -4px;
            display: inline;
            border-color: #006688 transparent;
            visibility: visible;
            position: absolute;
            border-style: solid;
            border-width: 5px 5px 0 0;

            @media screen and(max-width: 570px) {
                top: unset;
                right: unset;
                left: 0;
                bottom: -4px;
            }
        }
    }


    &__content {
        margin-left: 20px;
        border-bottom: 1px solid #E0E0E0;

        .article-detail-top {
            cursor: pointer;
        }

        @media screen and (max-width: 570px) {
            margin-left: 0;
        }
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__title {
        text-align: left;
        margin-bottom: 10px;

    }

    @media screen and (max-width: 450px) {

        &__title {
            h2 {
                font-size: 18px;
            }

        }
    }

    &__image {
        @media screen and (max-width: 768px) {
            width: 100%;
        }
    }

    &__desc {
        text-align: left;

        p {
            text-align: left;
            font-size: 14px;
        }

        .more-detail {
            font-size: 14px;
            margin: 15px 0;
        }

        .routes {
            margin: 15px 0;
        }

        p {
            padding-bottom: 1em;
        }
    }
}

.comment-container {
    position: relative;

    .comments_number {
        position: absolute;
        left: -100px;
        width: 85px;

        @media screen and (max-width: 570px) {
            position: unset;
        }
    }
}

.comments_number {
    width: 100%;
    margin-top: 4px;
    background-color: #00b6cc;
    padding: 6px 10px;
    color: #fff;
    font-size: 11px;
}

.comment-item {
    display: flex;
    padding: 30px 0;

}

.comment-item:not(:last-child) {
    border-bottom: 1px solid #E0E0E0;
}

.posted_by {
    font-size: 11px;
    color: #909090;
}

.comment-item p {
    color: #666;
    line-height: 150%;
    font-size: 12px;
    padding: 15px 0;
}

.comment_details {
    text-align: left;
    padding-left: 30px;
}

</style>
